import { builtinV1 } from '../../builtin'

// klinecharts 9.8.12 built-in 'DMA' (dist/index.esm.js), untouched: version 1 for existing instances only.
export default builtinV1({ id: 'DMA', label: 'Difference of Moving Averages', pane: 'sub', params: [10, 50, 10], outputs: ['dma', 'ama'] })
